import React from "react";
// import Preview from "./Preview";

const Blog = () => (
  <div className="mt-3">
    <div className="mb-4 text-lg">
      I generally tend to write on medium, but one day I may write here too.
      <span aria-label="shrug" role="img">
        🤷‍♀️
      </span>
    </div>
    {/* <Preview title="Sample blog post" /> */}
    {/* <div className="border border-black" /> */}
  </div>
);

export default Blog;



// WEBPACK FOOTER //
// ./src/Blog/index.js